import { Component, Input, OnInit } from '@angular/core';
import { IFinal } from '@tacliatech/types';

@Component({
  selector: 'roma-wrapper-deals',
  templateUrl: './wrapper-deals.component.html',
  styleUrls: ['./wrapper-deals.component.scss'],
})
export class WrapperDealsComponent implements OnInit {
  @Input()
  type: 'ADD' | 'EDIT' = 'ADD';

  @Input()
  customer: IFinal;

  @Input()
  isLoading = false;

  constructor() {}

  ngOnInit(): void {}
}
